module.exports = __webpack_public_path__ + "static/brasimpex -818716846cd8af9cb5b5eb7b16ae8f05.jpg";